import * as url from '@/client/services/url'

import ShwLink from '@/components/ShwLink'
import Alert from '@/components/UI/Alert'

export default function FAQHelpDeskSection({
  category,
}: {
  category?: url.faq.Category
}): JSX.Element {
  return (
    <Alert variant="info-blue">
      For a comprehensive list of FAQs, please visit our{' '}
      <ShwLink href={url.faq.getUrl(category)}>Help Desk</ShwLink>.
    </Alert>
  )
}
